module.exports = __webpack_public_path__ + "img/logo.e805c7fd.png";